import CurrencyInput from 'react-currency-input-field';
import { useTranslation } from 'react-i18next';
import { IconElements } from '../../../config/icons';
import { reverseFormatNumber } from '../../../utils/parsers';
import { FormGroup } from './FormGroup';

export const CurrencyFormGroup: React.FC<
    { button?: { label: string; onClick: () => void }; value?: number; onChange: (cents: number) => void } & {
        currencyInputProps?: React.ComponentProps<typeof CurrencyInput>;
    } & React.ComponentProps<typeof FormGroup>
> = ({ button, value, onChange, currencyInputProps = {}, ...rest }) => {
    const { className: currencyClassName, ...currencyRest } = currencyInputProps;
    const { t } = useTranslation('general');

    return (
        <FormGroup {...rest}>
            <div className="relative w-full">
                <CurrencyInput
                    type="text"
                    className={`w-full py-2 px-4 border border-gray-200 rounded-lg focus:outline-hidden font-medium ${currencyInputProps?.className}`}
                    fixedDecimalLength={0}
                    decimalsLimit={2}
                    intlConfig={{ currency: 'EUR', locale: 'nl-NL' }}
                    allowDecimals={false}
                    value={value === undefined ? undefined : value / 100}
                    onValueChange={(value = '', _) => {
                        const decimal = reverseFormatNumber(value, 'nl-NL');
                        onChange(Math.ceil(+decimal * 100));
                    }}
                    placeholder={t('euro-placeholder')}
                    prefix={t('euro-placeholder')}
                    {...currencyRest}
                />
                {button && (
                    <div
                        onClick={button.onClick}
                        className="w-60 absolute top-0 bottom-0 right-4 flex flex-row justify-end text-bnd-green items-center cursor-pointer hover:underline"
                    >
                        <span>{button.label}</span>
                        <IconElements.Calculator className="ml-2 h-6 w-6 text-bnd-green" />
                    </div>
                )}
            </div>
        </FormGroup>
    );
};
